module.exports = __webpack_public_path__ + "img/paper_plus.051161cd.svg";